import { render } from "./ktTopicInfo.vue?vue&type=template&id=5717b55b&scoped=true"
import script from "./ktTopicInfo.vue?vue&type=script&lang=js"
export * from "./ktTopicInfo.vue?vue&type=script&lang=js"

import "./ktTopicInfo.vue?vue&type=style&index=0&id=5717b55b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5717b55b"]])

export default __exports__